require('@babel/polyfill');
require('bootstrap');

require('./components/authentication/axios-interceptor');

require('./components/Router');
require('./config/chatra')